import React, { useEffect, useState } from 'react';
import LeaveDurationLayout from 'domain/people/leave/createupdate/duration/LeaveDurationLayout';
import useLeaveService from 'domain/people/leave/shared/leaveService';
import { InputLoader } from 'framework/ui/mui-builder';
import { useFormContext } from 'framework/form';
import { Box } from '@mui/material';

const LeaveDurationWidget = () => {
  const [days, setDays] = useState<Nullable<number>>(null);
  const { getDuration } = useLeaveService();
  const { data = {} } = useFormContext();
  const { type, startDate, endDate, employeeId, employeeAlias } = data;

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (type && startDate && endDate) {
      setIsLoading(true);
      getDuration(type, startDate, endDate, employeeAlias || employeeId)
        .then(response => setDays(response.duration))
        .catch(() => setDays(null))
        .finally(() => setIsLoading(false));
    }
  }, [type, startDate, endDate, employeeId, employeeAlias]); // eslint-disable-line react-hooks/exhaustive-deps

  return isLoading ? (
    <Box sx={{ marginBottom: '11px', '@media (min-width: 1440px)': { marginTop: '25px' } }}>
      <InputLoader />
    </Box>
  ) : (
    <LeaveDurationLayout days={days!} startDate={startDate} endDate={endDate} />
  );
};

export default LeaveDurationWidget;
